import { Injectable } from '@angular/core';
import { CurrentApiService, ElementsService, WSMessage, IElement } from 'dbweb-core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
export type exportStep = 'toPrepare' | 'inTheExpord' | 'complete';
export interface DoExportParam {
	Format: string;
	DB: string;
	TableName: string;
	Encoding: string;
	Columns: string[];
}
// exportåå§åçä¿¡æ¯
export interface ExportInfo {
	FromElement: string;
	Timeout: boolean;
	RowCount: number;
	Columns: {
		Name: string;
		Type: string;
		MaxLength: number;
	}[];
	DBNames: string[];
	DefaultTableName: string;
}
export interface DoExportResult {
	TaskID: string;
	Timeout: boolean;
	ZipFileSignURL: string;
	TaskInfoURL: string;
	TaskInfoSign: string;
	ResultURL: string;
	BrowseTaskElement: IElement;
}

export interface Column {
	selected?: boolean;
	Name: string;
	Type: string;
	MaxLength: number;
}
export interface ExportTaskWSMessage extends WSMessage {
	Data: {
		TaskID: string;
		Completed: boolean;
		Message: string;
		Data: number;
	};
}
@Injectable()
export class ExportService {
	step: exportStep = 'toPrepare';
	srcElementTitle: string;
	rowCount: number;
	format: 'csv' | 'txt' | 'json' | 'excel' | 'sqlite3' | 'mytable' = 'csv';
	encoding: 'utf8' | 'gbk' = 'utf8';
	dbName: string;
	tableName: string;
	columns: Column[];
	dbNames: string[];
	timeRemaining: number;
	exportProgress: number;
	zipFileURL: string;
	taskInfoURL: string;
	constructor(private eles: ElementsService, private api: CurrentApiService) {}
	isAllSelected() {
		return this.columns && this.columns.find(v => !v.selected) === undefined;
	}
	hasSelected() {
		return this.columns && this.columns.find(v => v.selected) !== undefined;
	}
	init() {
		return this.api.get<ExportInfo>('get-export-info').subscribe(v => {
			this.srcElementTitle = v.FromElement;
			this.rowCount = v.RowCount;
			this.columns = v.Columns;
			// this.columns = [...v.Columns, ...v.Columns, ...v.Columns]; //æµè¯é¿æ°æ®æ¶ä½¿ç¨
			this.columns.forEach(c => (c.selected = true));
			this.dbNames = v.DBNames;
			this.dbName = '';
			this.tableName = v.DefaultTableName;
		});
	}

	doExport(param: DoExportParam) {
		// console.log('è¿å¥postè¯·æ±');
		return this.api.post<DoExportResult>('do-export', param).pipe(
			tap(v => {
				// æ³¨åæ¥çä»»å¡æç»çurl
				this.eles.addElement(v.BrowseTaskElement);
				this.eles.setURLSign(v.TaskInfoURL, v.TaskInfoSign);
			})
		);
	}
}
